<template>
  <div>
    <h5 v-html="$t('filter.titles.' + key)" />
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>
      <b-select v-if="this.options" :options="this.options" v-model="selected" value-field="value" text-field="text"
        @input="transmitNewValue()" />
    </b-input-group>
  </div>
</template>

<script>
import dashboard from "@/mixins/api/dashboard";


export default {
    mixins: [dashboard],
    data() {
        return   {
            tKey: "filter.competitor",
            options: null,
            selected: null,
            icon: "flag",
            key: "competitor",
        };
    },
    methods: {
        transmitNewValue() {
            this.$emit("transmit", this.selected, this.key)
        }
    },
    async created() {
        await this.loadCompetitors();
        this.selected = this.options[0].value;
    },

}
</script>

<style>

</style>